<template>
  <div class="card">
    <!-- Если старт не в архивах -->
    <div
      v-if="!currentArchives.length"
      class="card-body"
    >
      <p class="text-muted mb-4">
        Старт не добавлен ни в один архив
      </p>
      <b-button
        variant="primary"
        @click="$bvModal.show('bv-modal-add-linked-archives')"
      >
        Добавить старт в архив
      </b-button>
      <b-button
        class="ml-2"
        variant="success"
        @click="$bvModal.show('bv-modal-create-linked-archives')"
      >
        Создать архив
      </b-button>
    </div>

    <!-- Если архивы есть -->
    <div
      v-else
      class="card-body"
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">
          Архивы
        </h5>
        <div>
          <b-button
            size="sm"
            variant="primary"
            class="mr-2"
            @click="$bvModal.show('bv-modal-add-linked-archives')"
          >
            Добавить в архив
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="$bvModal.show('bv-modal-create-linked-archives')"
          >
            Создать архив
          </b-button>
        </div>
      </div>

      <transition-group
        name="fade"
        tag="div"
        class="row"
      >
        <div
          v-for="archive in currentArchives"
          :key="archive.id"
          class="col-md-4 mb-3"
        >
          <div class="card h-100 shadow-sm linked-item-card">
            <div class="card-body text-center">
              <h5 class="card-title mb-2">
                {{ archive.name }}
              </h5>
              <p
                v-if="archive.description"
                class="card-text text-muted small mb-2"
              >
                {{ archive.description }}
              </p>
              <b-badge
                variant="info"
                class="mb-3"
              >
                {{ (archive.starts || []).length }} старт(ов)
              </b-badge>
              <b-button
                size="sm"
                variant="danger"
                @click="removeFromArchive(archive)"
              >
                <i class="fas fa-trash-alt" /> Удалить
              </b-button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- Модалки -->
    <DistanceModalAddLinkedArchives
      :all-archives="allArchives"
      :start-id="startId"
      @archive-added="fetchLinkedArchives"
    />
    <DistanceModalCreateLinkedArchives
      :start-id="startId"
      @archive-created="fetchLinkedArchives"
    />
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue'
import DistanceModalAddLinkedArchives from '@/views/starts/new-version/DistanceModalAddLinkedArchives.vue'
import DistanceModalCreateLinkedArchives from '@/views/starts/new-version/DistanceModalCreateLinkedArchives.vue'

export default {
  name: 'LinkedArchives',
  components: {
    BButton,
    BBadge,
    DistanceModalAddLinkedArchives,
    DistanceModalCreateLinkedArchives,
  },
  props: {
    allArchives: {
      type: Array,
      default: () => [],
    },
    startId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentArchives: [],
    }
  },
  watch: {
    allArchives: {
      handler() {
        this.findCurrentArchives()
      },
      immediate: true,
    },
  },
  methods: {
    findCurrentArchives() {
      this.currentArchives = (this.allArchives || []).filter(
        archive => (archive.starts || []).some(s => Number(s.id) === Number(this.startId)),
      )
      this.emitArchiveChanged()
    },

    emitArchiveChanged() {
      const archiveId = this.currentArchives.length ? this.currentArchives[0].id : null
      this.$emit('archive-changed', archiveId)
    },

    async fetchLinkedArchives() {
      try {
        const response = await this.$http.get('start/start-archive/all-archives')
        const allArchives = response.data
        this.$emit('update:allArchives', allArchives)
        this.currentArchives = (allArchives || []).filter(
          archive => (archive.starts || []).some(s => Number(s.id) === Number(this.startId)),
        )
        this.emitArchiveChanged()
      } catch (error) {
        console.error(error)
      }
    },

    async removeFromArchive(archive) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Вы уверены, что хотите удалить старт из архива "${archive.name}"?`,
        {
          title: 'Подтверждение удаления',
          okVariant: 'danger',
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          footerClass: 'p-2',
          centered: true,
        },
      )

      if (!confirmed) return

      try {
        const startIds = (archive.starts || [])
          .filter(s => Number(s.id) !== Number(this.startId))
          .map(s => s.id)

        const payload = {
          name: archive.name,
          description: archive.description || '',
          startIds,
        }

        await this.$http.put('start/start-archive/change-archive', payload, {
          params: { id: archive.id },
        })

        this.currentArchives = this.currentArchives.filter(a => a.id !== archive.id)

        this.$bvToast.toast(`Старт удалён из архива "${archive.name}"`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
        await this.fetchLinkedArchives()
      } catch (error) {
        console.error('Ошибка при удалении старта из архива:', error)
        this.$bvToast.toast('Ошибка при удалении старта из архива', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../scss/series-archives-shared.scss';
</style>
